import $ from 'jquery';
import Rellax from 'rellax';
import { Component } from '../core/component';

export class TextDisplayFirstLetter extends Component {
    constructor() {
        super();
        this.selector = '.text-display-first-letter';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            const firstLetterTextEl = $(element);
            const firstLetter = $(element).text().trim().charAt(0);
            firstLetterTextEl.prepend(`<div class="text-display-first-letter__letter-wrapper">${firstLetter}</div>`);
            /* eslint-disable no-unused-vars */
            const letterRellax = new Rellax('.text-display-first-letter__letter-wrapper', {
                speed: 0.7,
                center: true,
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/test-display-first-letter.js